import React from 'react';

export default function AuthLayout({ children }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 h-screen overflow-hidden">
      <section className="flex items-center justify-center px-12 lg:px-4 h-full overflow-y-auto">
        <div className="w-full max-w-xl">
          {children}
        </div>
      </section>
      
      {/* Right side - Image */}
      <section className="hidden md:block">
        <img 
          src="/auth.svg" 
          alt="StackGuard Authentication"
          className="w-full h-full object-cover" 
        />
      </section>
    </div>
  );
}
